import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const InvestmentApproachPage = lazy(() => import('../pages/investment-approach/page'));
const PortfolioPage = lazy(() => import('../pages/portfolio/page'));
const ValueCreationPage = lazy(() => import('../pages/value-creation/page'));
const SellYourBusinessPage = lazy(() => import('../pages/sell-your-business/page'));
const PartnerWithUsPage = lazy(() => import('../pages/partner-with-us/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/investment-approach',
    element: <InvestmentApproachPage />,
  },
  {
    path: '/portfolio',
    element: <PortfolioPage />,
  },
  {
    path: '/value-creation',
    element: <ValueCreationPage />,
  },
  {
    path: '/sell-your-business',
    element: <SellYourBusinessPage />,
  },
  {
    path: '/partner-with-us',
    element: <PartnerWithUsPage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
